/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectInstance} from "../models/object-instance";
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class PeopleInstancesResolver implements Resolve<ObjectInstance[]> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ObjectInstance[]> {
    try {
      return await this.mObjectService.getAllPeopleObjectInstances();
    } catch (error) {
      console.error("Problem resolving Device Types... Error: " + error, error);
    }
  }

}
